export const CLEAN_FORM = 'movilidad/reportefrecuenciavisita/clean-form';
export const ADVANCED_SEARCH_CLOSE = 'main/advanced-search-close';
export const ADVANCED_SEARCH_OPEN = 'main/advanced-search-open';
export const SET_STATE_FORM = 'movilidad/reportefrecuenciavisita/set-state-form';
export const UPDATE_FIELD_FILTER = 'movilidad/reportefrecuenciavisita/update-field-filter';
export const RECEIVE_V_LIST = 'movilidad/reportefrecuenciavisita/receive-v-list';
export const REQUEST_V_LIST = 'movilidad/reportefrecuenciavisita/request-v-list';
export const ERROR_V_LIST = 'movilidad/reportefrecuenciavisita/error-v-list';
export const SET_MASK = 'movilidad/reportefrecuenciavisita/set-mask';
export const SET_ORDER = 'movilidad/reportefrecuenciavisita/set-order';
export const RECEIVE_DATA= 'movilidad/reportefrecuenciavisita/receibe-data';
export const UPDATE_TABLE_COLUMN= 'movilidad/reportefrecuenciavisita/update-table-column';
export const SET_PAGE = 'movilidad/reportefrecuenciavisita/set-page';
export const SET_SELECTED_ROW = 'movilidad/reportefrecuenciavisita/set-selected-row';